import { Component, Element, h, Host } from "@stencil/core";

/**
 * UxTableCaptionNeo - Experimental table caption component
 * @slot - The content of the caption
 */
@Component({
    tag: "ux-table-caption-neo",
    styleUrls: ["table-caption-neo.scss"],
    shadow: true
})
export class TableRowNeo {
    @Element() host!: HTMLUxTableCaptionNeoElement;

    render() {
        return (
            <Host role="caption">
                <slot />
            </Host>
        );
    }
}
